<template>
    <v-server-table name="oshaSubTable" ref="oshaSubTable" url="/subcontractors/osha-db/list" :columns="columns" :options="options">

        <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
            <div class="clearfix d-md-none d-block"></div>

            <div class="float-left">
                <table-filters-2 ref="oshaSubTableFilters" filterUrl="/subcontractors/osha-db/filters" v-bind:filters="filters" :emptyFilters="filterDefs" :filterKey="filterKey" @filtersChanged="refreshTableData" @filtersCleared="filtersCleared">
                    <template slot-scope="slotProps">
                        <div class="d-inline-block">
                            <multi-select v-model="slotProps.filters['osha_db_establishments.site_state']" :btnLabel="(values) => ('States ('+values.length+')')" :selectOptions="slotProps.filterData.states" :options="{multi: true}"></multi-select>
                        </div>
                        <div class="d-inline-block">
                            <multi-select v-model="slotProps.filters['osha_db_establishments.sic_code']" :btnLabel="(values) => ('SIC Codes ('+values.length+')')" :selectOptions="slotProps.filterData.sic_codes" :options="{multi: true}"></multi-select>
                        </div>
                        <div class="d-inline-block">
                            <multi-select v-model="slotProps.filters['osha_db_establishments.naics_code']" :btnLabel="(values) => ('NAICS Codes ('+values.length+')')" :selectOptions="slotProps.filterData.naics_codes" :options="{multi: true}"></multi-select>
                        </div>
                    </template>
                </table-filters-2>
            </div>

            <div class="float-md-left ml-md-2">
                <i style="font-size: 20px;" class="fa fa-question-circle" title="Pin a record below to link it with your subcontractor. Any pinned data will show up on the pre-qualification form for quick reference."></i>
            </div>

            <div class="clearfix d-md-none d-block"></div>
        </div>

        <router-link slot="estab_name" slot-scope="props" :to="`/subcontractors/osha-db/view/${props.row.id}`" title="View Subcontractor">
            {{ props.row.estab_name }}
        </router-link>

        <template slot="id" slot-scope="props">
            <a href="javascript:void(0)" v-if="props.row.is_pinned" @click="togglePin(props.row.id, 0)"><i class="fa fa-thumb-tack text-primary"></i></a>
            <a href="javascript:void(0)" v-else @click="togglePin(props.row.id, 1)"><i class="fa fa-thumb-tack text-muted"></i></a>
        </template>

        <div slot="afterFilter" class="ml-2">
            <!-- <button type="button" class="btn btn-outline-success" v-on:click="exportSubcontractors()"><i class="fa fa-file-excel-o"></i> Export</button> -->
        </div>
    </v-server-table>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';

    export default {
        props: ['subcontractor_id', 'allow_pinning', 'allowFilterSaving'],

        data: function() {
            return {
                options: {
                    headings: {
                        id: 'Pin',
                        estab_name: 'Name',
                        site_city: 'City',
                        site_state: 'State',
                        naics_code: 'NAICS Code',
                        sic_code: 'SIC Code',
                        num_inspections: '# of Inspections',
                        num_violations: '# of Violations',
                        num_accident_injuries: '# of Accidents/Injuries',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'estab_name',
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = filterExtractor.extractFilters(this.filters);

                        if (this.subcontractor_id)
                        {
                            data.subcontractor_id = this.subcontractor_id;
                            if (!this.allow_pinning)
                            {
                                data.exclude_unpinned = 1;
                            }
                        }

                        return data;
                    },
                    uniqueKey: 'id',
                    saveState: true,
                    storage: 'local',
                },

                filterDefs: {
                    'osha_db_establishments.site_state': [],
                    'osha_db_establishments.sic_code': [],
                    'osha_db_establishments.naics_code': [],
                },

                filterKey: 'oshaSubFilters',
            }
        },

        computed: {
            columns() {
                if (this.subcontractor_id)
                {
                    return ['id', 'estab_name', 'site_city', 'site_state', 'naics_code', 'sic_code', 'num_inspections', 'num_violations', 'num_accident_injuries'];
                }
                return ['estab_name', 'site_city', 'site_state', 'naics_code', 'sic_code', 'num_inspections', 'num_violations', 'num_accident_injuries'];
            },

            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },
        },

        methods: {
            togglePin: function(estab_id, should_pin) {
                this.$http
                .post('subcontractors/osha-db/pin', {subcontractor_id: this.subcontractor_id, osha_establishment_id: estab_id, toggle: should_pin})
                .then(response => {
                    //Redraw the Table
                    this.$refs.oshaSubTable.refresh();
                })
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.oshaSubTable.setPage(1);
                this.$refs.oshaSubTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.oshaSubTableFilters.resetColVis(this.$refs.oshaSubTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.oshSubSavedFilters.setFilterParams(this.$refs.oshaSubTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.oshaSubTableFilters.setColVis(this.$refs.oshaSubTable);
            },
        },
    }
</script>
